module.exports = __webpack_public_path__ + "img/btimg.6c310874.png";